<template>
  <div ref="view" class="goods-page">
    <!-- 菜单栏（内嵌App时隐藏） -->
    <app-header :title="title" back-type="back-app" />

    <!-- 无限卡 -->
    <goods-vip-forever v-if="isVipForever" ref="vipForever" :goods="defaultGoods" />
    <!-- 通用商品内容 -->
    <goods-content v-else :content="goodsInfo.guideContent || goodsInfo.goodsContent" class="content" />

    <!-- 商品加载出来再显示 -->
    <div v-if="isShow" class="mask" @touchmove.prevent @click="isShow = false">
      <div class="wrap" @click.stop>
        <span class="closeMask" @click="isShow = false">
          <img src="../../../images/goods/close.png" alt="" />
        </span>
        <dl flex>
          <dt class="share-icon">
            <img :src="goodsInfo.shareImg" alt="" />
          </dt>
          <dd class="good-info">
            <p class="good-name">{{ goodsInfo.goodsName }}</p>
            <p class="good-price">¥{{ goodsInfo.salePrice }}</p>
          </dd>
        </dl>
        <div class="goods-item">
          <p class="tit">您已选择</p>
          <p class="good-name">
            <span
              :class="[goodsIndex === index ? 'active' : '']"
              @click="chooseGoodsFn(index, item)"
              v-for="(item, index) in goodsDetail"
              :key="item.goodsId"
            >
              {{ item.goodsName }}
            </span>
          </p>
        </div>
        <button class="btn btn-active" @click="onClickPayPre">立即购买</button>
      </div>
    </div>
    <div v-else class="foot">
      <div class="footer">
        <p class="price">
          <span class="shop-price">¥{{ salePriceMini || salePrice }}</span>
          <del class="original-price" v-if="goodsInfo.scribingPrice">¥{{ goodsInfo.scribingPrice }}</del>
        </p>
        <button class="btn" @click="onClickFn">立即报名</button>
      </div>
    </div>
    <!-- 订单弹幕气泡 -->
    <order-userbar :options="{ isVipForever }" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Toast } from 'mint-ui'
import Body from '@/mixins/body'
import { appUser, throttle, toFixedFloat } from '@/utils'
import { toLoginView } from '@/utils/init/env-init'
import GoodsComponents from './../components/goods'

// 操作名称
const action = 'buyGoods'

export default {
  name: 'goods',
  components: {
    ...GoodsComponents
  },
  data() {
    return {
      title: '友邻少年',
      goodsList: [],
      goodsIndex: 0, // 选择购买商品的索引
      isShow: false,
      shareIcon: '',
      name: '',
      price: '',
      goodsitem: 0
    }
  },
  mixins: [Body],
  computed: {
    ...mapGetters('goods/vip', [
      'goodsDetail',
      // 限购规则
      'limitData',
      'goodsDetail',
      'isNeedAuthentic'
    ]),
    ...mapGetters('payment/order', ['disCountOrderList']),
    ...mapGetters('args', ['goodsIds', 'shareCode']),
    // 商品是否联合限购
    hasLimit() {
      const { hasLimit } = this.limitData || {}
      return hasLimit
    },
    // 是无限卡购买（VIP商品 & 权益类型无限）
    isVipForever() {
      const { goodsInfo } = this
      const { goodsType, equityType } = goodsInfo
      return goodsType === '50001' && equityType === 'forever'
    },
    goodsInfo() {
      return this.goodsDetail[this.goodsIndex] || {}
    },
    salePriceMini() {
      var showPrice = ''
      if (this.goodsDetail.length > 1) {
        var index = this.goodsDetail.length - 1
        if (this.goodsDetail[0].salePrice < this.goodsDetail[index].salePrice) {
          showPrice = this.goodsDetail[0].salePrice + '-' + this.goodsDetail[index].salePrice
        } else {
          showPrice = this.goodsDetail[index].salePrice + '-' + this.goodsDetail[0].salePrice
        }
        return showPrice
      } else {
        return ''
      }
    },
    // shareCode 转换后的 goodsId
    defaultGoods() {
      const { goodsDetail: list } = this
      return list.length ? list[0] : {}
    },
    defaultGoodsId() {
      return this.defaultGoods.goodsId
    },
    // 计算实际支付金额
    discountTotal() {
      const total = this.disCountOrderList.discountTotal
      return total.toFixed(2)
    },
    salePrice() {
      const { goodsInfo } = this
      if (goodsInfo === null) return 0
      let salePrice = goodsInfo.salePrice || 0
      if (this.isVipForever) {
        salePrice = salePrice - this.discountTotal
      }
      salePrice = salePrice < 0 ? 0 : toFixedFloat(salePrice, 2)
      return salePrice
    }
  },
  created() {
    const goodsIds = this.goodsIds || ''
    this.goodsIdArr = goodsIds ? goodsIds.split('-').map(parseInt) : []
    // 如果没有登录，先去登录
    // if (!this.hasUser()) {
    //   return
    // }
    this.getGoodsDetail()
  },
  methods: {
    // 微信登录后，再次获取用户数据
    getWXUserAfter_getData() {
      // const { goodsDetail: list } = this
      // if (list.length === 1) {
      //   // USER-LOGIN-NEXT-ACTION: {"type":"button","action":"buyGoods"}
      //   this.enterAfterLogin(list)
      // }
      // 刷新商品
      setTimeout(() => {
        this.getGoodsDetail() // 刷新商品
      })
    },
    // 创建预付订单
    preCreate({ goodsId }) {
      const userId = appUser.userId
      const { limitData, isVipForever, isNeedAuthentic } = this
      console.log('this isNeedAuthentic', isNeedAuthentic)
      // 切换预创建订单服务
      const preCreate = () => {
        let data = { goodsId, userId }
        if (this.hasLimit) {
          Object.assign(data, limitData)
          return this.$store.dispatch('payment/order/preCreateByLimit', data)
        } else {
          if (isNeedAuthentic) {
            data = { goodsId, num: 1 }
            return this.$store.dispatch('payment/order/preCreateMini', data)
          } else {
            return this.$store.dispatch('payment/order/preCreate', data)
          }
        }
      }
      const preOrder = preCreate()
      preOrder.catch(({ code, message, data }) => {
        // 已经达到购买上限 | 用户已经具备该商品权益，无需购买商品 | 已经购买过训练营
        if (appUser.isNative && code === 30010) {
          // Toast({ message: '您已经具备该商品，无需购买', position: 'middle' })
          return
        }
        // 训练营招生结束！
        if (code === 30067) {
          Toast({ message, position: 'middle' })
        }
        if ([30007, 30010, 30026].indexOf(code) >= 0) {
          data = data || {}
          let name = ''
          let payStatus = {}
          // else 训练营的成功页面
          if (data.campNo) {
            name = 'campSuccess'
            const { userSno, startDate, adviserCode } = data
            const campDate = Date.getUTCDate(startDate, { format: 'yyyy-MM-dd' })
            payStatus = { goodsId, userSno, campDate, adviserCode }
          } else {
            name = 'success'
            const { iconUrl, nikeName, adviserCode } = data
            payStatus = { goodsId, iconUrl, nikeName, adviserCode, isVipForever }
          }

          const params = { id: goodsId }
          this.$store.commit('payment/order/setPayStatus', payStatus)
          this.$router.replace({ name, params })
        }
      })
      return preOrder
    },
    // 商品详情查询后，检查购买行为
    enterAfterLogin(res) {
      const { goodsInfoList: list } = res
      // 先处理单商品
      if (list && list.length !== 1) {
        return list
      }
      // 如果是无限卡，查询历史抵扣商品
      if (this.isVipForever) {
        const { goodsId } = list[0]
        const { userId } = appUser
        this.$store.dispatch('payment/order/getDisCountOrderList', { goodsId, userId })
      }
      return this.$store.dispatch('user/login/enterAfterLogin', { action }).then(action => {
        this.$nextTick(this.onClickPay)
        return action
      })
    },
    getGoodsDetail() {
      const data = {
        goodsIds: [],
        shareCode: this.shareCode
      }
      // console.log('shareCode',this.shareCode,data)
      this.$store
        .dispatch('goods/vip/getDetailByGoodsIdMini', data)
        // 检查支付操作（登录成功之后）继续
        .then
        // this.enterAfterLogin
        ()
    },
    // 设置分享数据
    setShareData() {
      const { shareMainTitle: title, shareSecondTitle: desc, shareImg: imgUrl } = this.defaultGoods
      if (title) {
        const link = location.href
        return { title, desc, link, imgUrl }
      }
    },
    chooseGoodsFn(ind, item) {
      this.goodsIndex = ind
      this.goodsitem = item
    },
    onClickFn() {
      if (this.goodsDetail.length > 1) {
        // 多商品购买
        this.isShow = true
      } else {
        this.onClickPayPre()
      }
    },
    // 检查用户
    hasUser() {
      // 无token去登录
      if (!this.hasToken({ action })) {
        toLoginView({ type: 'button', action })
        return false
      }
      return true
    },
    authDetail(source) {
      const that = this
      // 该商品需要认证，请求接口，查询当前用户的认证情况
      this.$store.dispatch('goods/vip/getAuthenticByUserId', {}).then(data => {
        console.log('结果', data)
        if (!data) {
          // 没提交过审核
          that.$router.push({ path: '/certification', query: { status: 5 } })
        } else {
          switch (data && data.status) {
            case 0:
            case 2: {
              // 跳去审核页面
              that.$router.push({ path: '/certification', query: { status: data.status } })
              break
            }
            case 1:
            case 3: {
              that.onClickPay()
            }
          }
        }
      })
    },
    onClickPayPre() {
      const that = this
      this.goodsitem = this.goodsitem || this.goodsDetail[0]
      console.log('this.goodsitem', this.goodsitem)
      if (this.goodsitem.isNeedAuthentic) {
        that.authDetail()
      } else {
        that.onClickPay()
      }
    },
    onClickPay: throttle(
      function () {
        if (!this.hasUser()) {
          return
        }
        // 无限卡需要勾选协议
        const { vipForever } = this.$refs
        if (vipForever && !vipForever.isChecked()) {
          return
        }
        // 跳转订单支付
        const orderView = () => {
          this.$router.push({
            path: `/confirm-order/${this.goodsInfo.goodsId}`,
            query: { paytype: 'goods' }
          })
        }
        this.preCreate(this.goodsInfo).then(orderView)
      },
      2000,
      { leading: true }
    )
  }
}
</script>

<style lang="less" scoped>
.goods-page {
  padding-bottom: 1.3rem;
  .content {
    img {
      width: 100%;
      height: auto;
    }
  }
  .foot {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    // iphoneX only
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    background-color: #fff;
  }
  .footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.18rem 0.47rem;
    border-top: 1px solid #eeeeee;
    background-color: #fff;
    .price {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .shop-price {
        font-size: 0.44rem;
        color: #00b25a;
        font-weight: bold;
        line-height: 0.54rem;
      }
      .original-price {
        color: #999999;
        font-size: 0.26rem;
        line-height: 0.32rem;
        margin-top: 0.1rem;
      }
    }
    .btn {
      padding: 0.24rem 0.4rem;
      background-color: #00b25a;
      border-radius: 0.12rem;
      color: #fff;
    }
  }
  .mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 99;
  }
  .wrap {
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    padding: 30px 20px 20px;
    background-color: #fff;
    .closeMask {
      display: flex;
      padding: 16px;
      position: absolute;
      top: 0;
      right: 0;
      img {
        width: 16px;
        height: 16px;
      }
    }
    .share-icon {
      width: 81px;
      height: 81px;
      img {
        width: 81px;
        height: 81px;
        border-radius: 2px;
      }
    }
    .good-info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 10px;
      .good-name {
        font-size: 18px;
        line-height: 22px;
      }
      .good-price {
        font-weight: bold;
        font-size: 18px;
        margin-top: 6px;
        color: #c42a1c;
      }
    }
    .goods-item {
      margin-top: 0.6rem;
      display: flex;
      flex-direction: column;
      .tit {
        font-size: 0.34rem;
      }
      .good-name {
        display: flex;
        > span {
          margin-top: 0.3rem;
          margin-right: 0.2rem;
          padding: 0.15rem 0.2rem;
          text-align: center;
          line-height: 0.4rem;
          font-size: 0.24rem;
          border-radius: 0.08rem;
          background-color: #eee;
          color: #666;
          // &:last-child {
          //   margin-right: .2rem!important;
          // }
        }
        .active {
          background-color: #00b25a;
          color: #fff;
        }
      }
    }
    .btn {
      width: 100%;
      padding: 0.24rem 0;
      margin-top: 0.4rem;
      color: #fff;
      font-size: 0.32rem;
      border-radius: 0.04rem;
      background-color: #00b25a;
    }
  }
}
</style>
